import styled from "styled-components";

export const Container = styled.div`
    height: 100vh;
    width: 100vw;

    .ol-rotate {
        position: absolute; /* Position the button relative to the map container */
        top: 17%; /* Distance from the bottom edge */
        left: 90%; /* Distance from the left edge */
        z-index: 1000; /* Ensure it appears above other map elements */
        background-color: white; /* Button background color */
        border-radius: 50%; /* Circular button */
        width: 56px; /* Button size */
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: black;
    }

    .ol-rotate button {
        font-size: 30px;
        font-weight: bold;
        border: teal;
        background: none;
        cursor: inherit;
    }

    .ol-rotate-reset button {
        font-size: 30px;
        font-weight: bold;
        border: teal;
        background: none;
        cursor: inherit;
    }
    .ol-compass {
        height: 41.25px;
        width: 41.25px;
        border: none;
    }

    .ol-zoom {
        position: absolute; /* Position the button relative to the map container */
        top: 17%; /* Distance from the bottom edge */
        left: 2%; /* Distance from the left edge */
        z-index: 1000; /* Ensure it appears above other map elements */
        background-color: white; /* Button background color */
        width: 42px;
        height: 82px;
        display: block;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: black;
    }

    .ol-zoom-in {
        height: 40px;
        width: 40px;
    }
    .ol-zoom-out {
        height: 40px;
        width: 40px;
    }

    .ol-zoom button {
        font-size: 30px;
        font-weight: bold;
        border: teal;
        background: none;
        cursor: inherit;
    }

    .ol-rotate img {
    	position: relative !important;
    	top: auto !important;
    	left: auto !important;
    }
`;
